import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 6H12l-2-2H2v16h20V6zm-2 12H4V8h16v10z"
}), 'FolderOpenSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FolderOpenSharp.js
// module id = 3773
// module chunks = 2